import { render, staticRenderFns } from "./centerForm.vue?vue&type=template&id=5807304e&scoped=true"
import script from "./centerForm.vue?vue&type=script&lang=js"
export * from "./centerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5807304e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5807304e')) {
      api.createRecord('5807304e', component.options)
    } else {
      api.reload('5807304e', component.options)
    }
    module.hot.accept("./centerForm.vue?vue&type=template&id=5807304e&scoped=true", function () {
      api.rerender('5807304e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/centerForm.vue"
export default component.exports